import {
  Typography,
  Accordion,
  AccordionSummary,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import LessonStandardList from '../../../card/LessonStandardList';
import TooltipWithIndicator from '../tooltip/TooltipWithIndicator';
import { guideToLevelingTooltipText } from '../../texts/TooltipText';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './LessonStandardSection.scss';

const defaultProps = {
  title: null,
  lessonLevel: null,
  standardList: [],
};

export default function LessonStandardSection(props) {
  const { title, lessonLevel, standardList, ...rest } = { ...defaultProps, ...filterUndefined(props) };
  const hasStandard = standardList && standardList.length > 0;
  return (
    <Accordion
      className='lesson-standard-section'
      data-test='lesson-standard-section'
      expanded={hasStandard ? undefined : true}
      {...rest}
    >
      <AccordionSummary
        className='standard-title'
        expandIcon={<ExpandMoreIcon className='expand-icon' />}
      >
        <Typography variant='h4' className='title-container'>
          <div className='title'>{title}</div> {hasStandard && (<div className='click-to-expand-label'>(Click to Expand)</div>)}
        </Typography>

        {lessonLevel ? (
          <div className='level-title'>
            <Typography variant='h4'>
              Level {lessonLevel}
            </Typography>
            <TooltipWithIndicator className='tooltip' {...guideToLevelingTooltipText} />
          </div>
        ) : null}
      </AccordionSummary>
      <div>
        {hasStandard ? (
          <ul className='standard-list' data-test='standard-list'>
            {
              standardList.map((standard) => (
                <li key={`lesson-standard-${standard.id}`} data-test={`lesson-standard-${standard.id}`}>
                  <div className='standard-code' data-test='standard-code'>
                    {standard.attributes.standardCode}
                  </div>
                  <div className='standard-description' data-test='standard-description'>
                    {standard.attributes.standardDescription}
                  </div>
                </li>

              ))
            }
          </ul>
        ) : (
          <div>
            This activity is not associated with any state standards.
          </div>
        )}

      </div>
    </Accordion>
  );
}
